import {
    Template,
    TemplateType,
    DocumentPartTemplateData,
    DocumentTemplateData,
    TaskTemplateData,
} from '@dv5/domain'
import {DocumentTemplateFormData, normalizePart} from './documentTemplateForm'

export function isDocumentPart(template: Template): template is Template & { templateData: DocumentPartTemplateData } {
    return template.templateType === TemplateType.DOCUMENT_PART
}

export function isDocumentTemplate(template: Template): template is Template & { templateData: DocumentTemplateData } {
    return template.templateType === TemplateType.DOCUMENT
}

export function isTask(template: Template): template is Template & { templateData: TaskTemplateData } {
    return template.templateType === TemplateType.TASK
}

export function getDocumentPartFormData(template: Template): { partHeader: string; partContent: string; partType: string } {
    const data = template.templateData as DocumentPartTemplateData
    return {
        partHeader: data.partHeader ?? '',
        partContent: data.partContent ?? '',
        partType: data.partType ?? '',
    }
}

export function getTaskFormData(template: Template): TaskTemplateData {
    const data = template.templateData as TaskTemplateData
    return {
        title: data.title ?? '',
        description: data.description ?? '',
        webHookUrl: data.webHookUrl ?? '',
    }
}

export function getDocumentTemplateFormData(template: Template): DocumentTemplateFormData {
    const data = template.templateData as Partial<DocumentTemplateData> | undefined
    return {
        sourceDocumentId: data?.sourceDocumentId ?? '',
        title: data?.title ?? '',
        parts: Array.isArray(data?.parts) ? data.parts.map(normalizePart) : [],
    }
}
